const icons = {
  campaign_list: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-clipboard-data"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
      <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
      <path d="M9 17v-4" />
      <path d="M12 17v-1" />
      <path d="M15 17v-2" />
      <path d="M12 17v-1" />
    </svg>
  ),
  // payment_register: (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="icon icon-tabler icon-tabler-report-money"
  //     width="20"
  //     height="20"
  //     viewBox="0 0 24 24"
  //     strokeWidth="1.5"
  //     stroke="#2c3e50"
  //     fill="none"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   >
  //     <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  //     <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
  //     <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
  //     <path d="M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
  //     <path d="M12 17v1m0 -8v1" />
  //   </svg>
  // ),
  // deposit_register: (
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     className="icon icon-tabler icon-tabler-checkup-list"
  //     width="20"
  //     height="20"
  //     viewBox="0 0 24 24"
  //     strokeWidth="1.5"
  //     stroke="#2c3e50"
  //     fill="none"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   >
  //     <path stroke="none" d="M0 0h24v24H0z" fill="none" />
  //     <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
  //     <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
  //     <path d="M9 14h.01" />
  //     <path d="M9 17h.01" />
  //     <path d="M12 16l1 1l3 -3" />
  //   </svg>
  // ),
  flash_report: (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-clipboard2-pulse" viewBox="0 0 16 16">
      <path d="M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z" />
      <path d="M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z" />
      <path d="M9.979 5.356a.5.5 0 0 0-.968.04L7.92 10.49l-.94-3.135a.5.5 0 0 0-.926-.08L4.69 10H4.5a.5.5 0 0 0 0 1H5a.5.5 0 0 0 .447-.276l.936-1.873 1.138 3.793a.5.5 0 0 0 .968-.04L9.58 7.51l.94 3.135A.5.5 0 0 0 11 11h.5a.5.5 0 0 0 0-1h-.128z" />
    </svg>
  ),
};

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
  id: "Reports",
  title: "reports",
  type: "group",
  role: [1, 2],
  children: [
    {
      id: "/reports/campaign-report",
      title: "Campaign Reports",
      type: "item",
      url: "/reports/campaign-report",
      icon: icons.campaign_list,
      role: [1, 2],
      breadcrumbs: false,
    },
    // {
    //   id: "/reports/campaign-list",
    //   title: "API Campaigns",
    //   type: "item",
    //   url: "/reports/campaign-list",
    //   icon: icons.campaign_list,
    //   role: [1, 2],
    //   breadcrumbs: false,
    // },
    // {
    //   id: "/reports/flash-report",
    //   title: "Flash Campaigns",
    //   type: "item",
    //   url: "/reports/flash-report",
    //   icon: icons.flash_report,
    //   role: [1, 2],
    //   breadcrumbs: false,
    // },
  ],
};

export default reports;
